import { makeStyles, tokens } from "@fluentui/react-components";
import { AtMentionItemClassName, AtMentionMeItemClassName } from "@ms/uno-constants/lib/local/ChatConstants";
export const useClasses = makeStyles({
    messageContainer: {
        marginTop: tokens.spacingVerticalXXS,
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacingVerticalXXS
    },
    messageContainerWithHeader: {
        marginTop: tokens.spacingVerticalM
    },
    namelineContainer: {
        display: "flex",
        columnGap: tokens.spacingHorizontalS,
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground3,
        alignItems: "center",
        marginLeft: "40px",
        marginBottom: "0px"
    },
    name: {
        maxWidth: "150px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    namelineContainerCurrentUser: {
        display: "flex",
        columnGap: tokens.spacingHorizontalS,
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground3,
        alignItems: "center",
        justifyContent: "flex-end",
        marginRight: tokens.spacingHorizontalXL,
        marginBottom: "0px"
    },
    namelineHidden: {
        display: "none"
    },
    messageWrapper: {
        width: "100%",
        display: "flex",
        flexDirection: "column"
    },
    /** Styles for chatMessage bubble */ chatMessageRoot: {
        paddingTop: "0"
    },
    chatMessage: {
        backgroundColor: tokens.colorNeutralBackground1,
        marginRight: "40px",
        paddingTop: tokens.spacingVerticalSNudge,
        paddingBottom: tokens.spacingVerticalS,
        maxWidth: "100%",
        minWidth: "0px",
        boxSizing: "border-box"
    },
    chatMyMessage: {
        backgroundColor: tokens.colorBrandBackground2,
        paddingTop: tokens.spacingVerticalSNudge,
        paddingBottom: tokens.spacingVerticalS,
        maxWidth: "100%",
        minWidth: "0px",
        boxSizing: "border-box"
    },
    /** Styles for the content of each chat message, including mentions */ chatMessageContent: {
        overflowX: "auto",
        [`& span.${AtMentionItemClassName}`]: {
            color: tokens.colorBrandForeground1,
            fontWeight: tokens.fontWeightBold
        },
        [`& span.${AtMentionMeItemClassName}`]: {
            color: tokens.colorPaletteDarkOrangeForeground3,
            fontWeight: tokens.fontWeightBold
        },
        "& a": {
            color: tokens.colorBrandForegroundLink
        },
        "& blockquote": {
            margin: 0
        }
    },
    deletedMessageContent: {
        fontStyle: "italic"
    },
    popoverSurface: {
        padding: "unset"
    }
});
